import { Common } from "./Common";

export class Committee extends Common {

  name?: string | null;
  code?: string | null;
  reg_no?: string | null;
  reg_date?: Date | null;

  logo?: string | null;
  banner?: string | null;
  moto?: string | null;
  type?: string | null;

  address?: string | null;
  pincode?: string | null;
  state?: string | null;
  district?: string | null;
  tag?: string | null;
  parent_id?: string | null;
  member_count?: number | null;
}
